module.exports = __webpack_public_path__ + "static/media/icon-select-album-check-1.4e188e5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/album-view/images/icon-select-album-check-1.svg
// module id = 1024
// module chunks = 57